import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PaymentInstallment } from 'src/app/entities/payment-installment';
import { BaseTableComponent } from '../base-table/base-table.component';
import { PaymentInstallmentService } from 'src/app/services/payment-installment.service';
import { AlertService } from 'src/app/services/alert.service';
import { fuseAnimations } from '@mobileia/layout-fuse';

@Component({
  selector: 'app-payment-installment',
  templateUrl: './payment-installment.component.html',
  styleUrls: ['./payment-installment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class PaymentInstallmentComponent extends BaseTableComponent<PaymentInstallment> implements OnInit {

  displayedColumns = ['id', 'title', 'installment', 'percent', 'type', 'actions'];
  configColumns = [
    {
      key: 'id',
      field_key: 'id',
      type: 'integer',
      title: 'ID',
      classes: 'font-weight-600'
    },
    {
      key: 'title',
      field_key: 'title',
      type: 'string',
      title: 'Titulo',
      classes: ''
    },
    {
      key: 'type',
      field_key: 'type',
      type: 'option',
      title: 'Tipo',
      classes: '',
      options: {
        '0': {
          title: 'FirstData'
        },
        '1': {
          title: 'MutualCard'
        },
      }
    },
    {
      key: 'installment',
      field_key: 'installment',
      type: 'string',
      title: 'Cuotas',
      classes: ''
    },
    {
      key: 'percent',
      field_key: 'percent',
      type: 'string',
      title: 'Porcentaje interes',
      classes: ''
    },
    /*{
      key: 'status',
      field_key: 'status',
      type: 'option',
      title: 'Estado',
      classes: '',
      options: {
        '0': {
          title: 'Pendiente'
        },
        '1': {
          title: 'Activo'
        },
      }
    },*/
  ];

  constructor(
    protected installmentService: PaymentInstallmentService,
    protected alertService: AlertService
  ) {
    super(alertService);
    this.service = installmentService;
  }

  ngOnInit(): void {
    this.loadItems();
  }

}